import React, { Component } from 'react'
import ShowMore from 'react-show-more'

export default class Terms extends Component {
	constructor(props) {
		super(props)

		this.state = {
			terms: [
				{
					id: 1,
					text: 'Voucher berlaku sampai 7 (tujuh) hari setelah pembelian.',
				},
				{
					id: 2,
					text: 'Voucher berlaku Tanpa Pembelian Minimal.',
				},
				{
					id: 3,
					text: ' Voucher berlaku untuk semua rekanan resmi di DOOgether dan semua metode pembayaran',
				},
				{
					id: 4,
					text: 'Voucher hanya dapat digunakan untuk satu kali booking kelas olahraga.',
				},
				{
					id: 5,
					text: 'Voucher tidak bisa digabungkan dengan voucher DOOgether lainnya.',
				},
				{
					id: 6,
					text: 'Voucher tidak dapat ditukarkan dengan uang tunai dalam kondisi apapun.',
				},
				{
					id: 7,
					text: 'Voucher hanya bisa digunakan untuk 1 (satu) transaksi.',
				},
				{
					id: 8,
					text: 'Voucher hanya bisa digunakan untuk 1 (satu) orang.',
				},
			],
		}
	}

	render() {
		return (
			<div className='terms'>
				<ShowMore more='Baca selengkapnya..' less='Baca lebih sedikit' anchorClass='show-more'>
					1. Voucher berlaku sampai 7 (tujuh) hari setelah pembelian. <br />
					2. Voucher berlaku Tanpa Pembelian Minimal. <br />
					3. Voucher berlaku untuk semua rekanan resmi di DOOgether dan semua metode pembayaran. <br />
					4. Voucher hanya dapat digunakan untuk satu kali booking kelas olahraga. <br />
					5. Voucher tidak bisa digabungkan dengan voucher DOOgether lainnya. <br />
					6. Voucher tidak dapat ditukarkan dengan uang tunai dalam kondisi apapun. <br />
					7. Voucher hanya bisa digunakan untuk 1 (satu) transaksi. <br />
					8.Voucher hanya bisa digunakan untuk 1 (satu) orang.
				</ShowMore>
			</div>
		)
	}
}
